"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldMultiple = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Chip_1 = __importDefault(require("@material-ui/core/Chip"));
const tooltip_1 = require("../../tooltip/tooltip");
const tooltip_field_hook_1 = require("../../tooltip/tooltip-field-hook");
const compose_refs_1 = require("../../../utils/compose-refs");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const text_field_1 = require("../text-field");
const text_field_multiple_styles_1 = require("./text-field-multiple-styles");
exports.TextFieldMultiple = (0, react_1.forwardRef)(function TextFieldMultiple({ form, id, name, onChange, disabled, value, onBlur, onFocus, startAdornment, endAdornment, error = false, type = 'text', autocomplete, inputProps, }, ref) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : [];
    const label = value.join(', ');
    const { chips, chip, inputWrapper, wrapper, wrapperDisabled } = (0, text_field_multiple_styles_1.useStyles)();
    const [textValue, setTextValue] = (0, react_1.useState)('');
    const { withTooltip, tooltipRef } = (0, tooltip_field_hook_1.useFieldTooltip)(value);
    const inputRef = (0, compose_refs_1.composeRefs)(ref, tooltipRef);
    const handleDelete = (0, event_callback_hook_1.useEventCallback)((index) => {
        if (onChange !== undefined) {
            onChange(value.filter((_, i) => i !== index));
        }
    });
    const handleKeyDown = (0, event_callback_hook_1.useEventCallback)((e) => {
        if (e.key === 'Enter' && textValue !== '') {
            e.preventDefault();
            if (onChange !== undefined) {
                onChange([...value, textValue]);
            }
            setTextValue('');
        }
        else if (e.key === 'Escape') {
            setTextValue('');
        }
    });
    const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        setTextValue(value !== null && value !== void 0 ? value : '');
    });
    const content = (react_1.default.createElement("div", { className: (0, clsx_1.default)('EasInput-root', wrapper, {
            [wrapperDisabled]: disabled,
        }) }, disabled ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(text_field_1.TextField, { disabled: true, value: label }))) : (react_1.default.createElement("div", { className: inputWrapper },
        react_1.default.createElement(text_field_1.TextField, { startAdornment: startAdornment, endAdornment: endAdornment, form: form, inputProps: {
                ...inputProps,
            }, ref: inputRef, id: id, name: name, disabled: disabled, value: textValue, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: handleKeyDown, error: error, type: type, autocomplete: autocomplete }),
        value.length > 0 && (react_1.default.createElement("div", { className: chips }, value.map((v, i) => (react_1.default.createElement(Chip_1.default, { key: i, label: v, className: chip, variant: "outlined", size: "small", onDelete: !disabled ? () => handleDelete(i) : undefined })))))))));
    return withTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: label, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
});
//# sourceMappingURL=text-field-multiple.js.map